import { render, staticRenderFns } from "./UserSelfPwd.vue?vue&type=template&id=3a751c01"
import script from "./UserSelfPwd.vue?vue&type=script&lang=js"
export * from "./UserSelfPwd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports